module.exports = __webpack_public_path__ + "img/diapositiva-12-2.eefb398e.png";